import { render } from "./TimeCourse.vue?vue&type=template&id=3cc95fa3&scoped=true"
import script from "./TimeCourse.vue?vue&type=script&lang=js"
export * from "./TimeCourse.vue?vue&type=script&lang=js"

import "./TimeCourse.vue?vue&type=style&index=0&id=3cc95fa3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc95fa3"]])

export default __exports__